/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useContext, useEffect } from 'react';
import { AppContext } from 'Context';
import cn from 'classnames';
import useSWR from 'swr';
import { dataFetcher, endpoints } from 'Api';
import { Grid } from '@material-ui/core';
import { Add, Category } from '@material-ui/icons';
import styles from './index.module.css';

const CreateSubCategory = ({ DragIcon, setSubCategoryDiv, content_type, isOpenSubCategoryDiv }) => {
  const [val, setVal] = useState(undefined);
  const {
    setAppSnackbar,
    langText,
    setShowAddSubCategoryModal,
    subCategoryRefreshTrigger
  } = useContext(AppContext);
  const [subCategory, setSubCategory] = useState(undefined);
  const commonText = langText?.common;
  const layoutText = langText?.layout;
  const [subCatId, setSubCatId] = useState(undefined);
  const [editing, setEditing] = useState(false);
  const { isValidating: gettingSubCategories, mutate: getSubCategories } = useSWR(
    endpoints.getMySubCategory,
    dataFetcher,
    {
      revalidateOnMount: true,
      onSuccess: ({ success, data }) => {
        if (success) {
          setSubCategory(data?.map(({ id, title }) => ({ name: title, value: id })));
        } else {
          setAppSnackbar({
            isVisible: true,
            type: 'error',
            message: 'Oops! Something went wrong while fetching your subcategories',
          });
        }
      },
      onError: (error) => {
        const responseData = error?.response?.data;
        setAppSnackbar({ isVisible: true, type: 'error', message: responseData || 'Oops! Something went wrong while fetching your subcategories' });
      },
    }
  );

  const { isValidating: removingSubCategory, mutate: deleteSubCategory } = useSWR([
    endpoints.deleteMySubCategory, subCatId
  ], {
    fetcher: (url, subCatId) => dataFetcher(url, {
      subCatId
    }),
    onSuccess: ({ success }) => {
      if (success) {
        getSubCategories();
        setAppSnackbar({
          isVisible: true,
          message: 'Sub-Category was removed',
        });
      } else {
        setAppSnackbar({ isVisible: true, type: 'error', message: 'Oops! Something went wrong' });
      }
    },
    onError: (error) => {
      const responseData = error?.response?.data?.message;
      setAppSnackbar({ isVisible: true, type: 'error', message: responseData || 'Oops! Something went wrong' });
    },
  });

  useEffect(() => {
    getSubCategories();
  }, []);

  // Refresh subcategories when a new one is created from the modal
  useEffect(() => {
    if (subCategoryRefreshTrigger > 0) {
      getSubCategories();
    }
  }, [subCategoryRefreshTrigger]);

  const removeSubCategory = (name, value) => {
    setVal(name);
    setSubCatId(value);
    if (value) {
      deleteSubCategory();
    }
  };

  return (
    <div className={styles.subCategoryGroup}>
      <div className={styles.subCategoryHeader}>
        <div
          className={cn({ [styles.dragIconContainer]: true, [styles.dragIconContainerType]: true })}
        >
          <DragIcon className={styles.dragIcon} style={{ opacity: 0 }} />
        </div>
        <div
          className={styles.contentTypeTitle}
          onClick={() => { setSubCategoryDiv(true); }}
        >
          <div className={styles.titleStyle}>{content_type}</div>
        </div>
        <div className={styles.contentGroupBody}>
          <div style={{ textAlign: 'center' }} className={styles.contentGroupBodyCell}>
            <div
              className={cn({ [styles.editContentTypeRef]: true, [styles.editContentTypeRefPosition]: true })}
              onClick={() => { setSubCategoryDiv(!isOpenSubCategoryDiv); }}
            >
              <div className={styles.editContentType}>{isOpenSubCategoryDiv ? (commonText?.back || 'Back') : (commonText?.edit || 'Edit')}</div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.addNewCategoryWrap}>
        {/* Add New Subcategory Button */}
        <div
          onClick={() => { setShowAddSubCategoryModal(true); }}
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '12px 16px',
            backgroundColor: '#f8fafc',
            borderRadius: 10,
            cursor: 'pointer',
            marginBottom: 16,
            border: '1px dashed #5aa5ef',
            transition: 'all 0.2s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#eff6ff';
            e.currentTarget.style.borderColor = '#3b82f6';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#f8fafc';
            e.currentTarget.style.borderColor = '#5aa5ef';
          }}
        >
          <Add style={{ fontSize: 20, marginRight: 10, color: '#5aa5ef' }} />
          <span style={{
            fontSize: 14,
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 600,
            color: '#5aa5ef'
          }}
          >
            {layoutText?.addNewSubCategory || 'Add New Subcategory'}
          </span>
        </div>

        {/* Existing Subcategories List */}
        <div className={styles.existingSubCatWrap}>
          {
            subCategory?.map(({ name, value }) => (
              <Grid container className={styles.subCatDiv} key={value}>
                <Grid item xs={9} style={{ display: 'flex', alignItems: 'center' }}>
                  <Category style={{ fontSize: 16, marginRight: 8, color: '#5aa5ef' }} />
                  <span className={styles.nameCell}>{name}</span>
                </Grid>
                <Grid onClick={() => { removeSubCategory(name, value); }} item xs={3} className={styles.removeSubCatButton}>
                  {removingSubCategory && value === subCatId ? (commonText?.removing || 'Removing') : (commonText?.remove || 'Remove')}
                </Grid>
              </Grid>
            ))
          }
        </div>
      </div>

    </div>
  );
};

export default CreateSubCategory;
